<template>
    <div id="channels">
        <div class="channels_actions" v-show="!searchMode && !editMode">
            <div @click="searchOn">
                <i class="icon-magnifier"></i>
            </div>
            <div @click="editChannelList">
                <i class="icon-pencil"></i>
            </div>
        </div>
        <div class="channels_search channels_top-bar" :class="{'active': searchMode}">
            <div @click="searchBack" class="back">
                <i class="icon-arrow-left"></i>
            </div>
            <input ref="searchInput" type="text" placeholder="поиск канала" v-model="filters.search">
        </div>
        <div class="channels_edit channels_top-bar" :class="{'active': editMode}">
            <div @click="editBack" class="back">
                <i class="icon-arrow-left"></i>
            </div>
            <div class="edit-text">Режим редактирования - чтобы скрыть или показать канал нажмите на иконку справа</div>
        </div>
        <ul id="channels_filtered_ul" v-show="filteredChannels.length > 0">
            <Channel
                    v-for="channel in filteredChannels"
                    :key="channel.id"
                    :channel="channel"
                    :editMode="editMode"
                    @openChannel="openChannel"
                    @apiGetChannelList="apiGetChannelList"
            ></Channel>
        </ul>

        <ul id="channels_ul" v-show="filteredChannels.length === 0">
            <Channel
                    v-for="channel in channels"
                    :key="channel.id"
                    :channel="channel"
                    :channelGroupId="getChannelGroupId(channel)"
                    :editMode="editMode"
                    @openChannel="openChannel"
                    @apiGetChannelList="apiGetChannelList"
                    @hideChannel="hideChannel"
                    @showChannel="showChannel"
            ></Channel>
        </ul>
    </div>
</template>
<script>
    import Channel from './Channel.vue';

    import {mapState, mapActions} from 'vuex'

    import Server from './../libs/server';

    export default {
        data() {
            return {
                searchMode: false,
                editMode: false
            }
        },
        computed: {
            ...mapState({
                channels: state => state.channels.channels,
                groups: state => state.channels.groups,
                protectionCode: state => state.channels.protectionCode
            }),
        },
        components: {Channel},
        props: ['filters', 'filteredChannels'],
        methods: {
            ...mapActions([
                'addChannelToFavorites',
                'removeChannelFromFavorites',
                'showToast',
                'showError',
                'checkProtectionCode',
                'showHiddenChannel',
                'hideVisibleChannel'
            ]),
            hideChannel(channel) {
                this.channelFiltering(channel, 'hide_channel')
            },
            showChannel(channel) {
                this.channelFiltering(channel, 'show_channel')
            },
            channelFiltering(channel, cmd) {
                Server.channelFiltering({
                    cmd: cmd,
                    protectCode: this.protectionCode,
                    cid: channel.id
                }, (err, data) => {
                    if (err) {
                        console.error(err.message);
                    }
                    else {
                        if (data.error) {
                            this.showError(data.error);
                        }
                        else {
                            if (cmd === 'show_channel') {
                                this.showHiddenChannel(channel.id);
   
                                this.showToast({
                                    message: 'Скрытие канала успешно отменено'
                                });
                            }
                            if (cmd === 'hide_channel') {
                                this.hideVisibleChannel(channel.id);

                                if (channel.is_favorite) {
                                    this.removeFromFavorites(channel);
                                }

                                this.showToast({
                                    message: 'Канал успешно скрыт'
                                });
                            }
                        }
                    }
                });
            },
            editChannelList() {
                this.checkProtectionCode(true)
                    .then(protectionCode => {

                        if (!protectionCode) return;

                        return this.apiGetChannelList(true, protectionCode, true, () => {
                            this.editMode = true;
                        })
                    });
            },
            searchOn() {
                this.$refs.searchInput.focus();
                this.searchMode = true;
            },
            searchBack() {
                this.$emit('clearSearch');
                this.searchMode = false;
            },
            editBack() {
                this.editMode = false;
                this.apiGetChannelList(false, '', true);
            },
            getChannelGroupId(channel) {
                const firstGroupChannel = this.channels.find((el) => {
                    return el.group_id === channel.group_id;
                });
                const elemId = 'channelGroup' + channel.group_id;
                return firstGroupChannel.id === channel.id ? elemId : '';
            },
            openChannel(channel) {
                this.$emit('openChannel', channel);
            },
            apiGetChannelList(show, protectionCode, ignoreLastUpdated, callback) {
                return this.$emit('apiGetChannelList', show, protectionCode, ignoreLastUpdated, callback);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// Channels.vue?5f52b310